import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=d8334ed0"
import script from "./EmployeeDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetails.vue?vue&type=style&index=0&id=d8334ed0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports